import {
    FETCH_CLIENT_CREDENTIALS,
    FETCH_CLIENT_CREDENTIALS_FAIL,
    FETCH_CLIENT_CREDENTIALS_SUCCESS,
    SET_CLIENT_BRANDS,
    SET_CLIENT_BRANDS_FAIL,
    SET_CLIENT_BRANDS_SUCCESS
} from './actionTypes';
import * as _ from 'lodash';

export const initialState = {
    data: [],
    // The credentials that have a change of brands in progress, by id
    busy: {},
    error: null,
    loading: false,
    loaded: false
};

export function clientCredentialsReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_CLIENT_CREDENTIALS:
            return { ...state, loading: true };
        case FETCH_CLIENT_CREDENTIALS_SUCCESS:
            return {
                ...state,
                data: _.sortBy(action.payload, c => _.toLower(c.email)),
                error: null,
                loading: false,
                loaded: true
            };
        case FETCH_CLIENT_CREDENTIALS_FAIL:
            return { ...state, error: action.payload, loading: false };
        case SET_CLIENT_BRANDS:
            return {
                ...state,
                busy: { ...state.busy, [action.payload.id]: true }
            };
        case SET_CLIENT_BRANDS_SUCCESS:
            return {
                ...state,
                data: _.map(state.data, credential =>
                    credential.id === action.payload.id
                        ? action.payload
                        : credential
                ),
                busy: _.omit(state.busy, action.payload.id)
            };
        case SET_CLIENT_BRANDS_FAIL:
            return {
                ...state,
                busy: _.omit(state.busy, action.payload.id)
            };
        default:
            return state;
    }
}
